import React from "react"
import { GENERIC_ERROR_CODES } from "./options.js"
import { pushGtmValues } from "@bappweb/utils";
import { isNullOrEmpty } from "@smpu-web/utils/utils"

export const getQueryStringWithParam = (param: string) => {
    let search = window.location.search;
    let urlParams = new URLSearchParams(search);

    for (const [key, value] of urlParams.entries()) {
        if (key.toLowerCase() === param) {
            return value;
        }
    }

    return null;
}

export const setGenericErrorInfoCode = (errorCode, sessionutils) => {

    let infoCode = "";
    if (isNullOrEmpty(sessionutils) || sessionutils == "" || isNullOrEmpty(sessionutils?.guid)) {
        switch (errorCode) {
            case GENERIC_ERROR_CODES.MSRED:
                infoCode = "BGEN51";
                break;
            case GENERIC_ERROR_CODES.MSIPTAL:
                infoCode = "BGEN52";
                break;
            case GENERIC_ERROR_CODES.NOTELIGIBILITY:
                infoCode = "BGEN53";
                break;
            default:
                infoCode = "BGEN0";
                break;
        }

        // pushDataLayer("/basvuru/kredi-karti/genericerror", false, infoCode)
        pushGtmValues({
            "event": "virtual_page_view",
            "content_group": "ticari_kredi_karti",
            "pageName": "genericerror",
            "pageTitle": "Ticari Kredi Kartı",
            "infoCode": infoCode
        })
    } else {
        pushGtmValues({
            event: "virtual_page_view",
            content_group: "ticari_kredi_karti",
            pageName: !isNullOrEmpty(sessionutils?.guid) ? "bkkyonlendirmesayfası" : "genericerror",
            pageTitle: "Ticari Kredi Kartı"
        })
    }


}